import React from 'react';
import { useNavigate } from 'react-router-dom';
import './package-pages.css';

const WarningIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
  </svg>
);

const PackageExpiredPage = ({ isGracePeriod = false }) => {
  const navigate = useNavigate();

  return (
    <div className="package-page">
      <div className="package-page__card">
        <WarningIcon
          className={`package-page__icon${isGracePeriod ? ' package-page__icon--warning' : ''}`}
        />

        <h1 className={`package-page__title${isGracePeriod ? ' package-page__title--warning' : ''}`}>
          {isGracePeriod ? 'Package Grace Period' : 'Package Expired'}
        </h1>

        <p className="package-page__message">
          {isGracePeriod
            ? 'Your package is currently in its grace period. To avoid service interruption, please renew your package.'
            : 'Your package has expired. To continue using our services, please renew your package.'}
        </p>

        <div className="package-page__actions">
          <button
            type="button"
            className={`package-page__btn${isGracePeriod ? ' package-page__btn--warning' : ''}`}
            onClick={() => navigate('/app/billing')}
          >
            Renew Package
          </button>
        </div>
      </div>
    </div>
  );
};

export default PackageExpiredPage;
